import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Import required for `typedi`
import "reflect-metadata";

import { App } from "./App";

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
